<template>
  <v-dialog
    :value="value"
    max-width="1100"
    scrollable
    persistent
    @input="onInput"
  >
    <v-card>
      <v-card-title class="dialog-header py-2">
        <v-icon class="mr-3" color="white" size="26">mdi-settings</v-icon>
        <span class="dialog-title">Setup</span>
        <v-spacer></v-spacer>
        <v-btn class="white--text my-0" icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-tabs
        v-model="tab"
        color="transparent"
        slider-color="success"
        class="setup-tabs"
      >
        <v-tab>
          <span class="setup-tab">Bus Change Schedule</span>
        </v-tab>
        <v-tab>
          <span class="setup-tab">Routes</span>
        </v-tab>
        <v-tab>
          <span class="setup-tab">Colors</span>
        </v-tab>
        <v-tab>
          <span class="setup-tab">Driver Notifications</span>
        </v-tab>
      </v-tabs>

      <v-card-text class="pa-0 setup-body">
        <div v-show="tab === 0">
          <bus-change-grades-setup-dialog
            v-if="value"
            embedded
            @changed="$emit('grades-changed', $event)"
          ></bus-change-grades-setup-dialog>
        </div>
        <div v-show="tab > 0">
          <bus-route-identity-dialog
            v-if="value && routesOpened"
            :value="true"
            embedded
            :active-panel="tab - 1"
            :can-manage-presets="canManagePresets"
            :branch="branch"
            :default-kind="defaultKind"
            @saved="$emit('routes-saved')"
          ></bus-route-identity-dialog>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import BusChangeGradesSetupDialog from "./BusChangeGradesSetupDialog.vue";
import BusRouteIdentityDialog from "./BusRouteIdentityDialog.vue";

export default {
  name: "BusChangeSetupDialog",
  components: {
    BusChangeGradesSetupDialog,
    BusRouteIdentityDialog,
  },
  props: {
    value: { type: Boolean, default: false },
    canManagePresets: { type: Boolean, default: false },
    branch: { type: String, default: "" },
    defaultKind: { type: String, default: "Regular" },
  },
  data: () => ({
    tab: 0,
    routesOpened: false,
  }),
  watch: {
    value(open) {
      if (!open) {
        this.routesOpened = false;
        return;
      }
      if (this.tab > 0) this.routesOpened = true;
    },
    tab(t) {
      if (this.value && t > 0) this.routesOpened = true;
    },
  },
  methods: {
    onInput(open) {
      if (!open) this.close();
    },
    close() {
      this.$emit("input", false);
    },
  },
};
</script>

<style scoped>
.dialog-header {
  background: linear-gradient(135deg, rgb(92, 184, 96) 0%, #388e3c 100%);
  color: white;
  padding: 8px 16px;
  align-items: center;
}

.dialog-title {
  font-size: 20px;
  font-weight: 400;
  line-height: 1.2;
}

.setup-tabs {
  flex: 0 0 auto;
}

.setup-tabs >>> .v-tabs__bar,
.setup-tabs >>> .v-tabs__wrapper,
.setup-tabs >>> .v-tabs__container {
  height: 40px;
}

.setup-tabs >>> .v-tabs__item {
  height: 40px;
  text-transform: none;
  color: #757575 !important;
  font-weight: 500;
  border-bottom: 3px solid transparent;
  opacity: 1;
}

.setup-tabs >>> .v-tabs__item--active {
  color: #2e7d32 !important;
  font-weight: 700;
  background: #e8f5e9;
  border-bottom-color: rgb(92, 184, 96);
}

.setup-tabs >>> .v-tabs__slider-wrapper {
  display: none;
}

.setup-tab {
  display: inline-flex;
  align-items: center;
  line-height: 1.15;
  text-transform: none;
}

.setup-tab-lock {
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
  opacity: 0.7;
}

.setup-body {
  background: #f4f6f4;
  min-height: 320px;
}
</style>
